import { render, staticRenderFns } from "./appointmentservicereport.vue?vue&type=template&id=5bf73195&scoped=true&"
import script from "./appointmentservicereport.vue?vue&type=script&lang=js&"
export * from "./appointmentservicereport.vue?vue&type=script&lang=js&"
import style0 from "./appointmentservicereport.vue?vue&type=style&index=0&id=5bf73195&prod&lang=css&"
import style1 from "./appointmentservicereport.vue?vue&type=style&index=1&id=5bf73195&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf73195",
  null
  
)

export default component.exports